import { signal } from '@preact/signals-react'

export const componentConfigSignal = signal({})
export const componentConfigLoadedSignal = signal(false)
export const componentConfigErrorSignal = signal(null)
export const componentPermanentIdSignal = signal(null)
export const ccApiInterfaceConfigSignal = signal({ apiInterface: [] })
export const ccCoreGlobalSignal = signal({})
export const ccDeviceConfigSignal = signal({ device: [] })
export const ccExpressManagerSignal = signal({})
export const ccMailServerSignal = signal({})
export const ccUtgGlobalSignal = signal({})

export const deviceConfigRecordSignal = signal(null)
export const deviceConfigRecordLoadedSignal = signal(false)
export const deviceConfigRecordErrorSignal = signal(null)

export const deviceConfigRecordsListSignal = signal([])
export const deviceConfigRecordsListLoadedSignal = signal(false)
export const deviceConfigRecordsListErrorSignal = signal(null)